
const styles = (theme) => ({
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
       // background: 'linear-gradient(45deg, #41a9f2 30%, #90f0ed 90%)'
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
        flexDirection: "row",
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6),
    },
    cardActions: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginRight:10
        //backgroundColor:'red'
    },
    cardActionsButton: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    media: {
        height: 0,
        paddingTop: '80%', // 16:9
      },
    avatarUploader: {
       width:"100%",
    }

});

export default styles;
